import React from "react";

import { InsightsRow, InsightsSkeletonList, SkeletonBox } from "./styles";
import { InsightsSkeletonRowsProps } from "./types";

const INSIGHT_BAR_WIDTHS = [72, 58, 44];

export const InsightsSkeletonRows: React.FC<InsightsSkeletonRowsProps> = ({
  label,
}) => (
  <InsightsSkeletonList aria-label={label}>
    {INSIGHT_BAR_WIDTHS.map((width) => (
      <InsightsRow key={width}>
        <SkeletonBox width="130px" height="14px" />
        <SkeletonBox width={`${width}%`} height="10px" />
        <SkeletonBox width="60px" height="14px" />
      </InsightsRow>
    ))}
  </InsightsSkeletonList>
);
